const { sprintf } = require('sprintf-js');

class ConsoleMirror extends Object {

  #superConsole;
  #superLog;
  #superInfo;
  #superError;
  #superWarn;
  #superDebug;

  #maxLogLength = 400;
  #log = [];

  attach() {
    this.#superConsole = console;
    this.#superLog = console.log; // eslint-disable-line no-console
    console.log = (...rest) => this.applyLog(this.#superLog, rest, '[log] '); // eslint-disable-line no-console
    this.#superInfo = console.info; // eslint-disable-line no-console
    console.info = (...rest) => this.applyLog(this.#superInfo, rest, '[info] '); // eslint-disable-line no-console
    this.#superError = console.error; // eslint-disable-line no-console
    console.error = (...rest) => this.applyLog(this.#superError, rest, '[error] '); // eslint-disable-line no-console
    this.#superWarn = console.warn; // eslint-disable-line no-console
    console.warn = (...rest) => this.applyLog(this.#superWarn, rest, '[warn] '); // eslint-disable-line no-console
    this.#superDebug = console.debug; // eslint-disable-line no-console
    console.debug = (...rest) => this.applyLog(this.#superDebug, rest, '[debug] '); // eslint-disable-line no-console
  }

  applyLog(superMethod, parameters, tag = '') {
    superMethod.apply(this.#superConsole, parameters);
    try {
      const format = (parameters && parameters.length && parameters.shift() || '').replace('%c', '%.0s'); // drop %c on the floor
      const message = sprintf(format, ...parameters);
      const date = (new Date()).toISOString();
      this.#log.push(`${tag}${date}: ${message}`);
      if (this.#log.length > this.#maxLogLength) {
        this.#log.splice(0, this.#log.length - this.#maxLogLength);
      }
    } catch (_error) {
      // sorry
    }
  };

  get log() {
    return this.#log;
  }
};

const consoleMirror = new ConsoleMirror();
export default consoleMirror;
